/**
 * @param {Vue} app
 * @param {UserOrganization[]} organizations
 * @param options
 */
export async function pickUserOrganization(app, organizations, options = { closeable: false }) {
	let component = () => import("../components/login/PickUserOrganization.vue")

	return new Promise((resolve, reject) => {
		app.$modal.show(
			component,
			{
				organizations,
				canCancel: options.closeable,
				onSelected: (/* string */ orgId) => {
					resolve(orgId)
				}
			},
			{ clickToClose: options.closeable, height: "auto" }
		)
	})
}
